import React, { FC, useRef, useState, useEffect } from "react";
import Moment from "react-moment";
import { TableDiv, TableWrapper, TableContainer, ScrollButton } from "./styles";

const Table: FC<any> = ({ searchResults }) => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [showScroll, setShowScroll] = useState(false);

  const formatCurrency = (price: any) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 4,
    }).format(price);
  };

  const checkScroll = () => {
    if (tableRef.current) {
      const { scrollWidth, clientWidth } = tableRef.current;
      setShowScroll(scrollWidth > clientWidth);
    }
  };

  useEffect(() => {
    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, [searchResults]);

  const scroll = (direction: "left" | "right") => {
    if (tableRef.current) {
      const scrollAmount = 200;
      tableRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <TableDiv>
      {showScroll && (
        <>
          <ScrollButton className="left" onClick={() => scroll("left")}></ScrollButton>
          
          <ScrollButton className="right" onClick={() => scroll("right")}></ScrollButton>
        </>
      )}

      <TableWrapper ref={tableRef} onScroll={checkScroll}>
        <TableContainer>
          <thead>
            <tr>
              <th>Local</th>
              <th>Modalidade de Venda</th>
              <th>Data</th>
              <th>Preço</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(searchResults) &&
              searchResults.map((item) => (
                <tr key={item.id}>
                  <td>{item.local}</td>
                  <td>{item.modalidade_venda}</td>
                  <td><Moment date={item.data} format={'DD/MM/YYYY'}/></td>
                  <td>{formatCurrency(item.preco)}</td>
                </tr>
              ))}
          </tbody>
        </TableContainer>
      </TableWrapper>
    </TableDiv>
  );
};

export default Table;
